import React from "react";
import "./App.css";
import { Route, Routes, Navigate } from "react-router-dom";
import PrivateRoute from "./modules/Auth/PrivateRoute";
import ProtectedRoute from "./modules/Auth/ProtectedRoute";
import CheckAuth from "./modules/Auth/authCheck";
import history from "./modules/Navigation";
import Login from "./pages/login/login";
import JobCreate from "./pages/jobCreate/jobcreate";
import MyWork from "./pages/myWork/mywork";
import NotificationFront from "./pages/notificationFront/notificationFront";
import NotificationDetails from "./pages/notificationDetails/notificationDetails";
import WorkDetail from "./pages/workDetails/workDetails";
import UserProfile from "./pages/userProfile/userProfile";
import JobView from "./pages/backoffice/jobView/jobView";
import Validate from "./pages/backoffice/validate/validate";
import Incentive from "./pages/backoffice/incentive/incentive";
import UserManagement from "./pages/backoffice/userManagement/userManagement";
import Customer from "./pages/backoffice/customer/customer";
import Allowance from "./pages/backoffice/allowance/allowance";
import Pending from "./pages/backoffice/pending/pending";
import Notification from "./pages/backoffice/notification/notification";
import ServiceReport from "./pages/backoffice/serviceReport/serviceReport";
import ServiceReportPreview from "./pages/backoffice/serviceReportPreview/serviceReportPreview";
import ReleaseNotes from "./components/releaseNote/ReleaseNotes";
import OtHours from "./pages/backoffice/otHours/otHours";
import SrStatics from "./pages/backoffice/srStatics/srStatics";
import ResetPassword from "./pages/resetPassword/resetPassword";
import JobViewService from "./pages/backoffice/jobView/jobViewService";
import JobCreateThisco from "./pages/jobCreate/jobCreateThisco";
import ResetPasswordBranch from "./pages/resetPasswordBranch/resetPasswordBranch";
CheckAuth();
const App = () => {
  const selectedTenant = localStorage.getItem("selected_tenant");
  const selectedTenantData = JSON.parse(selectedTenant);

  return (
    <>
      <Routes history={history}>
        <Route element={<ProtectedRoute />}>
          {selectedTenantData?.Tenant !== "Thisco" ? (
            <Route exact path="/create-job" element={<JobCreate />} />
          ) : (
            <Route exact path="/create-job" element={<JobCreateThisco />} />
          )}
          <Route exact path="/change-password" element={<ResetPassword />} />
          <Route exact path="/my-work/*" element={<MyWork />} />
          <Route exact path="/work-detail/:Id" element={<WorkDetail />} />
          <Route
            exact
            path="/notification-front/*"
            element={<NotificationFront />}
          />
          <Route
            exact
            path="/notification-details/:Id"
            element={<NotificationDetails />}
          />
          <Route exact path="/user-profile" element={<UserProfile />} />
        </Route>

        <Route element={<PrivateRoute />}>
          {selectedTenantData?.Tenant === "Thisco" ? (
            <Route exact path="/job-view" element={<JobView />} />
          ) : (
            <Route exact path="/job-view" element={<JobViewService />} />
          )}
          <Route exact path="/validate" element={<Validate />} />
          <Route exact path="/incentive" element={<Incentive />} />
          <Route exact path="/ot-hours" element={<OtHours />} />
          <Route exact path="/allowance" element={<Allowance />} />
          <Route exact path="/pending" element={<Pending />} />
          <Route exact path="/user" element={<UserManagement />} />
          <Route exact path="/customer" element={<Customer />} />
          <Route exact path="/notification" element={<Notification />} />
          <Route exact path="/service-report" element={<ServiceReport />} />
          {/* <Route
            exact
            path="/change_password"
            element={<ResetPasswordBranch />}
          /> */}
          <Route exact path="/sr-summary" element={<SrStatics />} />
          <Route
            exact
            path="/service-report-preview/:id"
            element={<ServiceReportPreview />}
          />
        </Route>

        <Route exact path="/" element={<Login />} />
        <Route exact path="/release-note" element={<ReleaseNotes />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

export default App;
